'use client';

import { UserAvatar } from '@/components/common/UserAvatar/UserAvatar';
import { useAuth } from '@/hooks/useAuth';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { useSession } from 'next-auth/react';
import Link from 'next/link';

interface UserMenuPopupProps {
  handleClose: () => void;
  openViewProfile: () => void;
}

const linkSx = {
  fontWeight: 600,
  borderRadius: '0.475rem',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  ml: '1.25rem',
  py: '0.65rem',
  px: '1.25rem',
  textDecoration: 'none',
  transition: 'none',
  '&:hover': {
    color: 'primary.main',
    backgroundColor: 'rgba(224, 236, 245, 0.5)',
    fontWeight: 800,
    transition: 'color 0.2s ease, background-color 0.2s ease',
  },
};

const UserMenuPopup = ({ handleClose, openViewProfile }: UserMenuPopupProps) => {
  const { data } = useSession();
  const { user } = useAuth();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        fontWeight: 500,
        py: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', pl: '1.75rem', pr: '1rem', py: '0.65rem' }}>
        <UserAvatar name={user?.name} pictureGuid={user?.pictureGuid} size={40} sx={{ mr: '1.25rem' }} />
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography sx={{ fontWeight: 800, fontSize: '1.15rem', lineHeight: 1.3, color: 'text.primary' }}>
            {data?.user?.name}
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '0.95rem',
              '&:hover': { color: 'primary.main', transition: 'color 0.2s ease' },
            }}
          >
            {data?.user?.email}
          </Typography>
          <Box
            component="button"
            onClick={openViewProfile}
            sx={{
              background: 'none',
              border: 'none',
              fontWeight: 500,
              fontSize: '0.95rem',
              cursor: 'pointer',
              p: 0,
              textAlign: 'left',
              whiteSpace: 'nowrap',
            }}
          >
            View Profile
          </Box>
        </Box>
      </Box>

      <Box component={Link} onClick={handleClose} href="/admin" sx={linkSx}>
        Manage
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', ml: '1.25rem', pl: '1.25rem', py: '0.65rem' }}>
        <Typography sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
          Version: {process.env.NEXT_PUBLIC_VERSION}
        </Typography>
      </Box>

      <Box sx={{ height: 0, borderBottom: '1px solid #eff2f5', my: '0.5rem' }} />

      <Box component={Link} href="/auth/logout" sx={linkSx}>
        Logout
      </Box>
    </Box>
  );
};

export default UserMenuPopup;
